export const PRO_PRICE = {
  RUB: 150,
};
